import { Action } from 'helpers/action-helpers';
import { Tenant } from 'types/tenants/tenant';
import { Guid } from 'types/guid';
import { NmvsProviderCredentials } from 'types/tenants/nmvs-provider-credentials';

export const GET_TENANT = 'GetTenantAction';
export const GET_TENANT_FROM_CACHE = 'GetTenantFromCacheAction';
export const GET_TENANT_ID_EXISTS = 'GetTenantIdExistsAction';
export const SAVE_TENANT = 'SaveTenantAction';
export const SAVE_TENANT_ID_EXISTS = 'SaveTenantIdExistsAction';
export const UPDATE_TENANT_PREFERENCES = 'UpdateTenantPreferencesAction';
export const UPDATE_NMVS_PROVIDER_CREDS = 'UpdateNmvsProviderCredentialsAction';
export const PROCESSING_TENANT = 'ProcessingTenantAction';
export const SET_SETTINGS_ERROR_MESSAGE = 'SetSettingsErrorMessageAction';

export class GetTenantAction extends Action {
  constructor() { 
    super(GET_TENANT);
  }
}

export class GetTenantFromCacheAction extends Action {
  constructor() { 
    super(GET_TENANT_FROM_CACHE);
  }
}

export class GetTenantIdExistsAction extends Action {
  constructor() { 
    super(GET_TENANT_ID_EXISTS);
  }
}

export class SaveTenantAction extends Action {
  constructor(public tenant: Tenant) { 
    super(SAVE_TENANT);
  }
}

export class SaveTenantIdExistsAction extends Action {
  constructor(public exists?: boolean) { 
    super(SAVE_TENANT_ID_EXISTS);
  }
}

export class UpdateTenantPreferencesAction extends Action {
  constructor(
    public tenantId: Guid,
    public language: string
  ) { 
    super(UPDATE_TENANT_PREFERENCES);
  }
}

export class UpdateNmvsProviderCredentialsAction extends Action {
  constructor(
    public tenantId: Guid,
    public nmvsProviderCredentials: NmvsProviderCredentials
  ) { 
    super(UPDATE_NMVS_PROVIDER_CREDS);
  }
}

export class ProcessingTenantAction extends Action {
  constructor() { 
    super(PROCESSING_TENANT);
  }
}

export class SetSettingsErrorMessageAction extends Action {
  constructor(
    public message: string
  ) { 
    super(SET_SETTINGS_ERROR_MESSAGE);
  }
}


// WEBPACK FOOTER //
// ./src/pages/settings/actions.ts